module.exports = __webpack_public_path__ + "media/images/background-email-9bc10fbbfdca7729c5333c553abcf963.jpg";